import React from "react";
import "./styles.sass";

export const Pagination = ({ totalResults, pageSize, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalResults / pageSize);

  // page number logic (1 2 3 ... 528)
 const getPageNumbers = () => {
  let pages = [];

  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return pages;
};

  return (
    <section className="table_footer_wrapper">
      <p>
        Showing {(currentPage - 1) * pageSize + 1}-
        {Math.min(currentPage * pageSize, totalResults)} of {totalResults} results
      </p>

      <section className="pagenation_wrapper">

        {/* Prev */}
        <section
          className={`prev_btn ${currentPage === 1 ? "disabled" : ""}`}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        >
          Previous
        </section>

        {/* Dynamic Pages */}
        {getPageNumbers().map((page, index) => (
          <section
            key={index}
            className={
              page === currentPage
                ? "one_btn"
                : page === "..."
                ? "dots"
                : "two_btn"
            }
            onClick={() => page !== "..." && onPageChange(page)}
          >
            {page}
          </section>
        ))}
        {/* Next */}
        <section
          className={`prev_btn ${currentPage === totalPages ? "disabled" : ""}`}
          disabled={currentPage === totalPages}
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        >
          Next
        </section>

      </section>
    </section>
  );
};
